module.exports = __webpack_public_path__ + "static/roboto-v20-latin-regular-60fa3c0614b8fb2f394fa29944c21540.woff";